import {HotelContainer} from '../../containers';
import './style.scss'
function Hotel(){
    return (
      <div id="hotelPage">
        <HotelContainer />
      </div>
    );
}
export default Hotel;